(function () {
  'use strict';

  // Variáveis
  const $modal = $('#modal-advance');
  const $modalConf = $('#modal-advance-conf');
  const $form = $('#form-advance');
  const $btnSubmit = $form.find('.btn-submit');
  let btnText = $btnSubmit.html();
  let sending = false;
  const defaultErrorMessage = 'Não foi possível realizar esta operação.';

  // Ações executadas antes e enquanto o formulário é processado
  function sendingForm() {
    sending = true;
    btnText = $btnSubmit.html();
    $btnSubmit.prop('disabled', true).html('<div class="btn-spinner"></div> Aguarde');
  }

  // Ações executadas quando o form é processado com sucesso
  function successForm(resp) {
    console.log(resp);
    resetForm();
    try {
      resp = JSON.parse(resp);
      // Sucesso
      if (resp.status == 'success') {
        $modalConf.find('[data-total]').html('R$ ' + formatMoneyBR(resp.data.total));
        $modalConf.find('[data-fee]').html('- R$ ' + formatMoneyBR(resp.data.fee));
        $modalConf.find('[data-subtotal]').html('R$ ' + formatMoneyBR(resp.data.subtotal));
        $modal.modal('hide');
        $modalConf.modal('show');
      }
      // Erro
      else {
        if (resp.status == 'warning') {
          Toast.fire({
            type: 'warning',
            title: resp.mensagem,
          });
        } else {
          Toast.fire({
            type: 'error',
            title: resp.mensagem,
          });
        }
      }
    } catch (error) {
      console.log(error);
      Toast.fire({
        type: 'error',
        title: defaultErrorMessage,
      });
    }
  }

  // Ações executadas quando ocorre algum erro ao processar o form
  function errorForm(xhr, status, exception) {
    console.log(exception);
    resetForm();
    Toast.fire({
      type: 'error',
      title: defaultErrorMessage,
    });
  }

  // Retorna o formulário ao estado inicial (Cadastro)
  function resetForm(clearInputs = false) {
    sending = false;
    $btnSubmit.prop('disabled', false).html(btnText);
  }

  // Envia o formulário
  $form.on('submit', function (ev) {
    ev.preventDefault();
    if (!sending) {
      const formData = new FormData($form[0]);
      $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: formData,
        contentType: false,
        cache: false,
        processData: false,
        beforeSend: sendingForm,
        success: successForm,
        error: errorForm,
      });
    }
  });
})();
